// extracted by mini-css-extract-plugin
module.exports = {"mobileBreakPoint":"425px","screenWidthMobile":"375px","screenWidthDesktop":"1308px","Background":"background_Background__3G_V-"};